import { SearchesService } from '../services'

export default (params) => {
  return SearchesService.updateStatusSearch(params)
    .then((response) => {
      if (!response) {
        const error = new Error('HTTP_ERROR')
        error.response = response
        return Promise.reject(error)
      }

      return response.data
    })
    .catch((error) => Promise.reject(error))
}
